module.exports = __webpack_public_path__ + "static/media/35_B.20035834.png";